module.exports = __webpack_public_path__ + "img/desc.ea764142.jpg";